import Vue from 'vue'
import axios from '@/libs/axios'

export default {
  name: 'PermissionsComponent',
  data: {
    permissions: [],
    roles: [],
  },
  install() {
    Vue.prototype.$permissions = () => this
  },
  async fetchAccess(callback) {
    return axios.get(`/v1/companies/${Vue.prototype.$activeCompany().data.company.id}/user/permissions`)
      .then(user => {
        this.data.permissions = user.data.permissions
        this.data.roles = user.data.roles
        if (callback) {
          callback()
        }
      })
  },
  hasAny(haystack, needles) {
    let missing = false
    if (needles) {
      needles.forEach(needle => {
        if (!this.hasPermission(needle)) {
          missing = true
        }
      })
    }

    return missing === false
  },
  hasRole(role) {
    return this.data.roles && this.data.roles.includes(role)
  },
  hasAnyRole(roles) {
    return roles ? roles.some(role => this.hasRole(role)) : false
  },
  hasAnyPermissions() {
    return !(!this.data.permissions.user.length && !this.data.permissions.company_user.length)
  },
  hasPermission(permission) {
    if (this.data.permissions) {
      if (this.data.permissions.company_user && this.data.permissions.company_user.includes(permission)) {
        return true
      }

      if (this.data.permissions.user && this.data.permissions.user.includes(permission)) {
        return true
      }
    }

    return false
  },
  hasPermissionsToMenuItem(item) {
    if (!item) return false

    // Check roles
    if (item.roles) {
      return this.hasAnyRole(item.roles)
    }

    // Check permissions
    if (item.permissions) {
      const hasCompanyUserPermission = item.permissions.companyUser
        && this.hasAny(this.data.permissions.company_user, item.permissions.companyUser)

      const hasUserPermission = item.permissions.user
        && this.hasAny(this.data.permissions.user, item.permissions.user)

      return !!(hasCompanyUserPermission
        || hasUserPermission
        || (!item.permissions.companyUser && !item.permissions.user))
    }

    // Check conditions
    if (item.conditions) {
      let result = true
      item.conditions.forEach(condition => {
        // Enter conditions here
        if (condition === 'hasCallbacks') {
          if (!this.$activeCompany().data.company.callbacks) {
            result = false
          }
        }
      })

      // If all conditions matched
      return result === true
    }

    // Default: Add item if no roles, permissions, or conditions
    return true
  },
}
